import type { MaterialsSource } from '@felix/ui';
import { officeApi, uploadCatalog } from './api.js';

/**
 * Ofiste malzeme kataloğu ve gemi stoğu (ADR 0026): katalog ofiste yönetilir ve Excel'den içe
 * aktarılır; gemi stoğu geminin verisidir, ofiste salt okunur (stok yazma yok, mimari belge §8).
 */
export const officeMaterialsSource: MaterialsSource = {
  scope: 'web',
  vessels: () => officeApi.vessels(),
  categories: () => officeApi.materialCategories(),
  materials: (query) => officeApi.materials(query),
  material: (id) => officeApi.material(id),
  stock: (vesselId, options) => officeApi.vesselStock(vesselId, options),
  movements: (vesselId, options) => officeApi.stockMovements(vesselId, options),
  catalog: {
    create: (input) => officeApi.createMaterial(input),
    update: (id, patch) => officeApi.updateMaterial(id, patch),
    importFile: (file) => uploadCatalog(file),
  },
};
